module.exports = __webpack_public_path__ + "static/img/aws.51dbb04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/aws.svg
// module id = Ckog
// module chunks = 1